import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  useDeletePublicNoticeMutation,
  useGetAllPublicNoticesQuery,
} from "../../redux/publicNoticeApi";
import PublicNoticeCard from "./PublicNoticeCard";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/Utils";
import { showConfirmDialog } from "../showConfirmDialog/ShowConfirmDialog";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const PublicNotices = () => {
  const [page, setPage] = useState(1);

  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < data?.totalPages) setPage((prev) => prev + 1);
  };
  const { data, error, isLoading, isFetching } = useGetAllPublicNoticesQuery({
    page,
  });
  const loading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [deletePublicNotice, { isLoading: isDeleteLoading }] =
    useDeletePublicNoticeMutation();

  const handleDeletePublicNotice = async (id) => {
    try {
      const response = await deletePublicNotice(id).unwrap();
      if (response.success) {
        toast.success(response.message);
      }
    } catch (err) {
      console.error("Public Notice error:", err);
      showErrorToast(err);
    }
  };

  const handleDeleteConfrim = (id) => {
    showConfirmDialog({
      title: "Delete Public Notice",
      message: "Are you sure you want to delete this public notice?",
      type: "danger",
      onConfirm: () => {
        handleDeletePublicNotice(id);
      },
    });
  };
  return (
    <div className="flex flex-col lg:gap-10 md:gap-6 gap-4 bg-white rounded-xl lg:p-4 p-3 h-full">
      <div className="flex justify-between items-center">
        <p className="text-[#05004E] font-semibold lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem]">
          Public Notices
        </p>
        <div className="flex items-center">
          <NavLink
            to={"/public-notices/add-public-notice"}
            className="lg:w-[12rem] md:w-[10rem] w-max bg-[#00643b] text-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
          >
            + Add New
          </NavLink>
        </div>
      </div>
      <div className=" flex flex-col gap-4 w-full">
        {isLoading || isFetching ? (
          <div className=" grid 2xl:grid-cols-4 xl:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-3 gap-2">
            {loading.map((i) => (
              <div
                key={i}
                className=" w-full aspect-square bg-[#efefef] animate-pulse rounded-xl"
              ></div>
            ))}
          </div>
        ) : (
          data && (
            <>
              {data?.totalPages === 0 ? (
                <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#05004E]">
                  No Public Notice Found
                </div>
              ) : (
                <div className=" grid 2xl:grid-cols-4 xl:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-3 gap-2">
                  {data?.publicNotices?.map((publicNotice) => (
                    <div
                      key={publicNotice?._id}
                      className=" relative w-full flex  bg-[#efefef] lg:p-3 p-2 rounded-xl "
                    >
                      <PublicNoticeCard publicNotice={publicNotice} />

                      <div className=" absolute lg:top-3 lg:right-3 top-2 right-2 lg:p-2 p-1.5 rounded-es-xl bg-[#efefef] z-10 flex justify-end items-center lg:gap-2 gap-1">
                        <NavLink
                          to={`/public-notices/update-public-notice/${publicNotice?._id}`}
                          className={`capitalize lg:w-[4rem] w-[3rem]  bg-blue-500 text-center text-white lg:text-sm text-[11px] font-medium lg:py-2 py-1 rounded-lg hover:bg-blue-800`}
                        >
                          edit
                        </NavLink>{" "}
                        <button
                          onClick={() => handleDeleteConfrim(publicNotice?._id)}
                          disabled={isDeleteLoading ? true : false}
                          className={`capitalize lg:w-[4rem] w-[3rem]  bg-red-500 text-center text-white lg:text-sm text-[11px] font-medium lg:py-2 py-1 rounded-lg hover:bg-red-800`}
                        >
                          Delete
                        </button>{" "}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className=" flex justify-between items-center">
                <div className=" text-[#0000004f]">
                  Showing record page {data?.currentPage} 0f {data?.totalPages}
                </div>
                <div className=" flex items-center gap-4">
                  <div
                    onClick={handlePrev}
                    disabled={page === 1}
                    className={`bg-[#efefef] p-2  rounded-xl ${
                      page === 1
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowBack className="size-6" />
                  </div>
                  {data?.currentPage}
                  <div
                    onClick={handleNext}
                    disabled={page === data?.totalPages}
                    className={`bg-[#efefef] p-2  rounded-xl ${
                      page === data?.totalPages
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowForward className="size-6" />
                  </div>
                </div>
              </div>
            </>
          )
        )}
      </div>
      {error && (
        <p className=" text-red-500 text-center md:text-[1rem] text-sm bg-red-100 p-2 rounded-lg">
          {error?.data?.message}
        </p>
      )}
    </div>
  );
};

export default PublicNotices;
